type ContactLinkProps = {
  href: string;
  children: React.ReactNode;
};

export default function ContactLink({ href, children }: ContactLinkProps) {
  return (
    <a
      href={`https://www.magical-trip.com${href}`}
      target="_blank"
      rel="noopener noreferrer"
      className="ui-ContactUsLink"
    >
      {children}
    </a>
  );
}
